export interface Entity {

    id: string;

}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
